import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDhaFT_6ikvTO65Dt49KN4jLoVs5ZC65fE",
  authDomain: "apr-spotlight.firebaseapp.com",
  projectId: "apr-spotlight",
  storageBucket: "apr-spotlight.firebasestorage.app",
  messagingSenderId: "87259478850",
  appId: "1:87259478850:web:85fa7140edf78e4928e6db",
  measurementId: "G-S8V7Y1YM0H"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Configure Google Auth Provider for Google Workspace SSO
// Get internal domains from environment (e.g., "@aprco.com")
const internalDomains = (import.meta.env.VITE_INTERNAL_DOMAINS || '@aprco.com')
  .split(',')
  .map(d => d.trim())
  .filter(d => d.startsWith('@'));

// If we have internal domains, configure Google provider with domain restriction
// Use the first internal domain (remove @) as the hosted domain
const primaryDomain = internalDomains[0]?.replace('@', '') || 'aprco.com';

// Check if we're using the emulator
const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true' || import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST;

// Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();

// Set custom parameters
googleProvider.setCustomParameters({
  prompt: 'select_account' // Always show account selector
});

// Connect to emulator in development if enabled
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true' || import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST) {
  const emulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST || 'localhost:9099';
  try {
    connectAuthEmulator(auth, `http://${emulatorHost}`, { disableWarnings: true });
    console.log(`✅ Firebase Auth connected to emulator at ${emulatorHost}`);
  } catch (error) {
    // Emulator already connected, ignore
    console.log('Firebase Auth emulator already connected');
  }
}

export default app;
